export const LEGACY_USERNAME_PROMPT_DISMISSED_KEY =
  "civix:legacyUsernamePromptDismissed";

export const isLegacyUsernamePromptEnabled =
  process.env.REACT_APP_ENABLE_LEGACY_USERNAME_PROMPT !== "false";

export function readLegacyUsernamePromptDismissed() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(LEGACY_USERNAME_PROMPT_DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
}

export function setLegacyUsernamePromptDismissed(dismissed) {
  if (typeof window === "undefined") return;
  try {
    if (dismissed) {
      localStorage.setItem(LEGACY_USERNAME_PROMPT_DISMISSED_KEY, "true");
    } else {
      localStorage.removeItem(LEGACY_USERNAME_PROMPT_DISMISSED_KEY);
    }
  } catch {
    // ignore storage errors
  }
}

export function logLegacyUsernamePromptEvent(eventName, meta = {}) {
  // Lightweight telemetry until formal analytics pipeline is wired.
  console.info("[legacy_username_prompt]", eventName, meta);
}
